<app-abandoned-reservation-header [user]="user" [translationType]="'AUTOS'">
</app-abandoned-reservation-header>
<app-abandoned-reservation-body [hasImage]="false">
  <ng-container content>
    <app-auto-reservation [reservation]="reservation">
    </app-auto-reservation>
    <app-abandoned-reservation-actions [itineraryId]="itinerary?.Id" [reservationType]="reservationType"
      [userId]="user?.id" [isMobile]="isMobile" [isLoadingCancellation]="isLoadingCancellation"
      (cancelEvent)="cancelEvent.emit(reservation?.Id)">
    </app-abandoned-reservation-actions>
  </ng-container>
</app-abandoned-reservation-body>